<template>
  <div class="globalSettins_page">
    <div class="status_list">
      <MonitoringStatusItem
        v-for="(list, key) in status_list"
        :key="key"
        class="setting-item"
        :list="list"
        :title="key"
        @edit="new_API"
      />
    </div>
  </div>
</template>

<script>
import GlobalSettingsEdit from '../GlobalSettings/Edit/Index.vue'
import MonitoringStatusItem from './Item/Index.vue'
export default {
  name: 'MonitoringStatus',
  components: {
    MonitoringStatusItem
  },
  data () {
    return {
      status_list: {}
    }
  },
  mounted () {
    this.$http.v1.getMonitoringStatus((response) => {
      this.status_list = response.data
    })
  },
  methods: {
    new_API (val) {
      var t = this.$createElement(GlobalSettingsEdit, {props: {ips: val}, on: {close: () => { this.$modal.hide('dynamic-modal') }, update: (val) => { this.update(val) }}})
      let temp = {render () { return t }}
      this.$modal.show(temp, {}, {height: 'auto', name: 'dynamic-modal'})
    }
  }
}
</script>

<style lang="scss" scoped>
  .globalSettins_page{
    height: 100%;
    overflow-y: auto;
    &::-webkit-scrollbar{
      width: 10px;
    }
  }
  .card_add{
    margin-bottom: 15px;
  }
  .status_list{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    .setting-item{
      width: calc(33% - 10px);
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }

  @media (max-width: 1440px) {
    .status_list{
      .setting-item{
        width: 50%;
      }
    }
  }

  @media (max-width: 768px) {
    .status_list{
      .setting-item{
        width: 100%;
      }
    }
  }
</style>
